import type { EventModel } from '@bryntum/schedulerpro'

const selectableEventType: uui.domain.client.rm.RouteStep['type'][] = ['pickup', 'delivery']

export function isEventSelectable(event: EventModel) {
  const type = event.getData('type') as uui.domain.client.rm.RouteStep['type']
  return selectableEventType.includes(type)
}
